import React from 'react';
import DisplayTemplate from '../displayTemplate';
import { getYouTubeVideoId } from '../../utils';

export default function Video({ contentType, onPlay, onTimeUpdate, ref, content, contentDisplayType, contentUrl, mediaStyle, overrideHTML, renderDefault = false, helpText, templateType, ...props }) {
    const Component = () => {
        // Check if it's a YouTube URL
        const isYouTubeUrl = contentUrl?.includes('youtube.com') || contentUrl?.includes('youtu.be');

        if (isYouTubeUrl) {
            const videoId = getYouTubeVideoId(contentUrl);
            return (
                <iframe
                    width="100%"
                    height="250"
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    style={styles.container}
                />
            );
        }
        return (
            <video
                ref={ref}
                controls
                controlsList="nodownload"
                onContextMenu={(e) => e.preventDefault()}
                style={styles.container}
                onPlay={onPlay}
                onTimeUpdate={onTimeUpdate}
            >
                <source src={contentUrl} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

        );
    }
    return renderDefault ? <Component /> : <DisplayTemplate templateType={templateType} components={[Component]} {...props} />
}

const styles = {
    container: {
        width: '100%',
        maxWidth: '100%',
        height: '250px',
    }
}